import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";
import {
  VerificationAnomalyLevel,
  VerificationParentEntityType,
  MessageResponse,
} from "./physicalTechnicalVerifications";

export { VerificationAnomalyLevel, VerificationParentEntityType };
export type { MessageResponse };

export enum LegalVerificationDocumentTypes {
  VEHICLE_HYPOTHECATION = "VEHICLE_HYPOTHECATION",
  VEHICLE_DEALER_TAX_INVOICE = "VEHICLE_DEALER_TAX_INVOICE",
  VEHICLE_CERSAI_SEARCH_REPORT = "VEHICLE_CERSAI_SEARCH_REPORT",
  PLANT_MACHINERY_DEALER_TAX_INVOICE = "PLANT_MACHINERY_DEALER_TAX_INVOICE",
  PLANT_MACHINERY_CERSAI_SEARCH_REPORT = "PLANT_MACHINERY_CERSAI_SEARCH_REPORT",
  COMMERCIAL_EQUIPMENT_DEALER_TAX_INVOICE = "COMMERCIAL_EQUIPMENT_DEALER_TAX_INVOICE",
  COMMERCIAL_EQUIPMENT_CERSAI_SEARCH_REPORT = "COMMERCIAL_EQUIPMENT_CERSAI_SEARCH_REPORT",
  PRECIOUS_METAL_PLEDGE_AGREEMENT = "PRECIOUS_METAL_PLEDGE_AGREEMENT",
  PRECIOUS_METAL_OWNERSHIP_DECLARATION = "PRECIOUS_METAL_OWNERSHIP_DECLARATION",
  RESIDENTIAL_REAL_ESTATE_REGISTERED_SALE_DEED = "RESIDENTIAL_REAL_ESTATE_REGISTERED_SALE_DEED",
  RESIDENTIAL_REAL_ESTATE_PRIMARY_TITLE_DEED = "RESIDENTIAL_REAL_ESTATE_PRIMARY_TITLE_DEED",
  RESIDENTIAL_REAL_ESTATE_CHAIN_DEED = "RESIDENTIAL_REAL_ESTATE_CHAIN_DEED",
  RESIDENTIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED = "RESIDENTIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED",
  RESIDENTIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE = "RESIDENTIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE",
  RESIDENTIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT = "RESIDENTIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT",
  COMMERCIAL_REAL_ESTATE_REGISTERED_SALE_DEED = "COMMERCIAL_REAL_ESTATE_REGISTERED_SALE_DEED",
  COMMERCIAL_REAL_ESTATE_PRIMARY_TITLE_DEED = "COMMERCIAL_REAL_ESTATE_PRIMARY_TITLE_DEED",
  COMMERCIAL_REAL_ESTATE_CHAIN_DEED = "COMMERCIAL_REAL_ESTATE_CHAIN_DEED",
  COMMERCIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED = "COMMERCIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED",
  COMMERCIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE = "COMMERCIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE",
  COMMERCIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT = "COMMERCIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT",
  INDUSTRIAL_REAL_ESTATE_REGISTERED_SALE_DEED = "INDUSTRIAL_REAL_ESTATE_REGISTERED_SALE_DEED",
  INDUSTRIAL_REAL_ESTATE_PRIMARY_TITLE_DEED = "INDUSTRIAL_REAL_ESTATE_PRIMARY_TITLE_DEED",
  INDUSTRIAL_REAL_ESTATE_CHAIN_DEED = "INDUSTRIAL_REAL_ESTATE_CHAIN_DEED",
  INDUSTRIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED = "INDUSTRIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED",
  INDUSTRIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE = "INDUSTRIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE",
  INDUSTRIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT = "INDUSTRIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT",
  AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED = "AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED",
  AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED = "AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED",
  AGRICULTURAL_LAND_PARCEL_CHAIN_DEED = "AGRICULTURAL_LAND_PARCEL_CHAIN_DEED",
  AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT = "AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT",
  NON_AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED = "NON_AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED = "NON_AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_CHAIN_DEED = "NON_AGRICULTURAL_LAND_PARCEL_CHAIN_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "NON_AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  NON_AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "NON_AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  NON_AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT = "NON_AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_REGISTERED_SALE_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_REGISTERED_SALE_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_PRIMARY_TITLE_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_PRIMARY_TITLE_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CHAIN_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CHAIN_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CERSAI_SEARCH_REPORT = "INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CERSAI_SEARCH_REPORT",
  RESIDENTIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_CHAIN_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_CHAIN_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "RESIDENTIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  RESIDENTIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "RESIDENTIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  RESIDENTIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT = "RESIDENTIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT",
  COMMERCIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_CHAIN_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_CHAIN_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED = "COMMERCIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED",
  COMMERCIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE = "COMMERCIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE",
  COMMERCIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT = "COMMERCIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT",

  OTHERS = "OTHERS",
}

export interface LegalVerificationFields {
  document_type: LegalVerificationDocumentTypes;
  parent_entity_type: VerificationParentEntityType;
  parent_entity_id: string;
  prelogin_details?: Record<string, any>;
  current_details?: Record<string, any>;
  anomaly?: VerificationAnomalyLevel;
}

export interface LegalVerification extends LegalVerificationFields {
  verification_id: string;
}

export interface UpsertLegalVerificationsRequest {
  verifications: LegalVerification[];
}

export interface GetLegalVerificationsResponse {
  verifications: LegalVerification[];
}

export interface GetLegalVerificationsParams {
  case_id: string;
}

export interface UpsertLegalVerificationsParams {
  case_id: string;
  request: UpsertLegalVerificationsRequest;
}

const LegalVerificationsAPI = {
  getLegalVerifications: async (params: GetLegalVerificationsParams) => {
    const response: AxiosResponse<GetLegalVerificationsResponse> =
      await axiosInstance.get(
        `/v1/cases/${params.case_id}/legal-verifications`,
      );

    return response.data;
  },

  upsertLegalVerifications: async (
    params: UpsertLegalVerificationsParams,
  ) => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.put(
        `/v1/cases/${params.case_id}/legal-verifications`,
        params.request,
      );

    return response.data;
  },
};

export default LegalVerificationsAPI;
